import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import "./AuthPage.css";
import API_BASE_URL from "../../config";

const SignUp = () => {
  const history = useHistory();

  const [email, setEmail] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [password, setPassword] = useState("");
  const [cellphone, setCellphone] = useState("");
  const [consent, setConsent] = useState(true);
  const [phoneConsent, setPhoneConsent] = useState(true);
  const [zipcode, setZipcode] = useState("");
  const [ageGroupId, setAgeGroupId] = useState("");
  const [genderId, setGenderId] = useState("");
  const [selectedGenres, setSelectedGenres] = useState([]);
  const [error, setError] = useState("");
  const [showOptions, setShowOptions] = useState(false);

  const [signupStarted, setSignupStarted] = useState(false);
  const [signupSubmitted, setSignupSubmitted] = useState(false);

  const [ageGroups, setAgeGroups] = useState([]);
  const [genders, setGenders] = useState([]);
  const [genres, setGenres] = useState([]);
  const [childrenUnder18, setChildrenUnder18] = useState("");

  useEffect(() => {
    const fetchOptions = async () => {
      try {
        const [ageRes, genderRes, genreRes] = await Promise.all([
          fetch(`${API_BASE_URL}/age-groups`),
          fetch(`${API_BASE_URL}/genders`),
          fetch(`${API_BASE_URL}/genres`),
        ]);

        setAgeGroups(await ageRes.json());
        setGenders(await genderRes.json());
        setGenres(await genreRes.json());
      } catch (err) {
        console.error("Failed to fetch lookup data:", err);
      }
    };

    fetchOptions();
  }, []);

  // useEffect(() => {
  //   logActivity("signup_opened");

  //   return () => {
  //     if (
  //       !signupSubmitted &&
  //       (email || firstName || lastName || cellphone || zipcode)
  //     ) {
  //       logActivity("signup_abandoned", {
  //         email,
  //         firstName,
  //         lastName,
  //         cellphone,
  //         consent,
  //         phoneConsent,
  //         zipcode,
  //         ageGroupId,
  //         genderId,
  //         selectedGenres,
  //       });
  //     }
  //   };
  // });
  // useEffect(() => {
  //   logActivity("signup_opened");

  //   return () => {
  //     if (
  //       !signupSubmitted &&
  //       (email ||
  //         firstName ||
  //         lastName ||
  //         cellphone ||
  //         zipcode ||
  //         ageGroupId ||
  //         genderId ||
  //         selectedGenres.length > 0)
  //     ) {
  //       const data = {};
  //       if (email) data.email = email;
  //       if (firstName) data.firstName = firstName;
  //       if (lastName) data.lastName = lastName;
  //       if (cellphone) data.cellphone = cellphone;
  //       if (zipcode) data.zipcode = zipcode;
  //       if (ageGroupId) data.ageGroupId = ageGroupId;
  //       if (genderId) data.genderId = genderId;
  //       if (selectedGenres.length > 0) data.selectedGenres = selectedGenres;

  //       if (consent !== null) data.consent = consent;
  //       if (phoneConsent !== null) data.phoneConsent = phoneConsent;

  //       data.timestamp = new Date().toISOString();
  //       data.userAgent = navigator.userAgent;
  //       data.screenSize = `${window.innerWidth}x${window.innerHeight}`;
  //       data.referrer = document.referrer;

  //       logActivity("signup_abandoned", data);
  //     }
  //   };
  // }, [
  //   email,
  //   firstName,
  //   lastName,
  //   cellphone,
  //   zipcode,
  //   ageGroupId,
  //   genderId,
  //   selectedGenres,
  //   consent,
  //   phoneConsent,
  //   signupSubmitted,
  // ]);
  useEffect(() => {
    const handleBeforeUnload = () => {
      if (
        !signupSubmitted &&
        (email ||
          firstName ||
          lastName ||
          cellphone ||
          zipcode ||
          ageGroupId ||
          genderId ||
          selectedGenres.length > 0)
      ) {
        const event_data = {};
        if (email) event_data.email = email;
        if (firstName) event_data.firstName = firstName;
        if (lastName) event_data.lastName = lastName;
        if (cellphone) event_data.cellphone = cellphone;
        if (zipcode) event_data.zipcode = zipcode;
        if (ageGroupId) event_data.ageGroupId = ageGroupId;
        if (genderId) event_data.genderId = genderId;
        if (selectedGenres.length > 0)
          event_data.selectedGenres = selectedGenres;

        event_data.consent = consent;
        event_data.phoneConsent = phoneConsent;
        event_data.timestamp = new Date().toISOString();
        event_data.userAgent = navigator.userAgent;
        event_data.screenSize = `${window.innerWidth}x${window.innerHeight}`;
        event_data.referrer = document.referrer;

        const formData = new URLSearchParams();
        formData.append("event_type", "signup_abandoned");
        formData.append("event_data", JSON.stringify(event_data));

        navigator.sendBeacon(`${API_BASE_URL}/activity`, formData);
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [
    email,
    firstName,
    lastName,
    cellphone,
    zipcode,
    ageGroupId,
    genderId,
    selectedGenres,
    consent,
    phoneConsent,
    signupSubmitted,
  ]);

  const logActivity = async (eventType, data = {}) => {
    try {
      await fetch(`${API_BASE_URL}/activity`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("jwt")}`,
        },
        body: JSON.stringify({ event_type: eventType, event_data: data }),
      });
    } catch (err) {
      console.error("Activity logging failed:", err);
    }
  };

  const handleSignUp = async (e) => {
    e.preventDefault();
    setError("");
    setSignupSubmitted(true);

    try {
      const response = await fetch(`${API_BASE_URL}/signup`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: email.toLowerCase(),
          first_name: firstName,
          last_name: lastName,
          password,
          cellphone,
          consent,
          phone_consent: phoneConsent,
          zipcode,
          age_group_id: ageGroupId,
          gender_id: genderId,
          genres: selectedGenres,
          children_under_18: childrenUnder18,
        }),
      });

      if (response.ok) {
        history.push("/signin");
      } else {
        const errorData = await response.json();
        setError(errorData.error || "An error occurred during signup.");
      }
    } catch (error) {
      setError("An error occurred during signup. Please try again later.");
      console.error("Error:", error);
    }
  };

  return (
    <div className="auth-container">
      <form className="auth-form" onSubmit={handleSignUp}>
        <h1>Sign Up</h1>
        <h5>(and Vote)</h5>

        <input
          type="text"
          placeholder="First name"
          value={firstName}
          onChange={(e) => setFirstName(e.target.value)}
          required
        />
        <input
          type="text"
          placeholder="Last name"
          value={lastName}
          onChange={(e) => setLastName(e.target.value)}
          required
        />
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />

 <select
              id="ageGroup"
              value={ageGroupId}
              onChange={(e) => setAgeGroupId(e.target.value)}
            >
              <option value="">Select age group (Optional)</option>
              {ageGroups.map((group) => (
                <option key={group.id} value={group.id}>
                  {group.label}
                </option>
              ))}
            </select>

        <input
          type="tel"
          placeholder="Cell phone (Optional)"
          value={cellphone}
          onChange={(e) => setCellphone(e.target.value)}
        />

        <div className="checkbox-container">
          <input
            type="checkbox"
            checked={consent}
            onChange={(e) => setConsent(e.target.checked)}
          />
          <span>
            I agree to receive emails from MPT. I may unsubscribe at any time.
          </span>
        </div>

        <div className="checkbox-container">
          <input
            type="checkbox"
            checked={phoneConsent}
            onChange={(e) => setPhoneConsent(e.target.checked)}
          />
          <span>
            I agree to receive phone calls or text messages from MPT. I may
            unsubscribe at any time.
          </span>
        </div>

        <button
          type="button"
          className="auth-toggle-button"
          onClick={() => setShowOptions(!showOptions)}
          style={{ marginBottom: "15px" }}
        >
          {showOptions ? "Hide Optional Preferences" : "Tell Us More (Optional)"}
        </button>

        {showOptions && (
          <div className="optional-section">
            <input
              type="text"
              placeholder="Zipcode"
              value={zipcode}
              onChange={(e) => setZipcode(e.target.value)}
            />
            <select
              id="gender"
              value={genderId}
              onChange={(e) => setGenderId(e.target.value)}
            >
              <option value="">Select gender</option>
              {genders.map((g) => (
                <option key={g.id} value={g.id}>
                  {g.label}
                </option>
              ))}
            </select>
            <label>Select Your Top Genres (Ranked):</label>
            <div className="genre-box">
              <div className="genre-list">
                {genres.map((g) => {
                  const rank = selectedGenres.indexOf(g.id);
                  const isSelected = rank !== -1;
                  return (
                    <button
                      type="button"
                      key={g.id}
                      className={`genre-item ${isSelected ? "selected" : ""}`}
                      onClick={() => {
                        if (isSelected) {
                          setSelectedGenres(
                            selectedGenres.filter((id) => id !== g.id)
                          );
                        } else if (selectedGenres.length < 8) {
                          setSelectedGenres([...selectedGenres, g.id]);
                        }
                      }}
                    >
                      {g.name} {isSelected ? `( ${rank + 1})` : ""}
                    </button>
                  );
                })}
                <label>How many children under 18 are in your home?</label>
                <select
                  value={childrenUnder18}
                  onChange={(e) => setChildrenUnder18(e.target.value)}
                >
                  <option value="">Select number</option>
                  <option value="0">0</option>
                  <option value="1">1</option>
                  <option value="2">2</option>
                  <option value="3">3</option>
                  <option value="4">4+</option>
                </select>
              </div>
            </div>
          </div>
        )}

        <button type="submit" className="auth-button">
          Sign Up
        </button>
        {error && <p className="error-message">{error}</p>}
        <p>
          Already have an account? <a href="/signin">Sign In</a>
        </p>
      </form>
    </div>
  );
};

export default SignUp;
